import {
  MDBCard,
  MDBCardBody,
  MDBCol,
  MDBCollapse,
  MDBContainer,
  MDBIcon,
  MDBNavbarToggler,
  MDBRow,
} from 'mdbreact'
import React, { useState } from 'react'

import { Link } from 'gatsby'
import styled from 'styled-components'

const MDBCardCompMenu = styled(MDBCard)`
  width: 100%;
  margin: 0px;
  padding: 0px;
  position: relative;
  left: 50%;
  top: 14px !important;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 1;
`

const MDBCardBodyComp = styled(MDBCardBody)`
  text-align: left;
  @media only screen and (max-width: 767px) {
    padding-top: 0px;
  }
  ul {
    width: 100%;
    margin: 0px;
    padding: 0px;
    list-style-position: outside;
    list-style: none;
    li {
      width: 100%;
      background: none;
      border-bottom: 1px #ccc solid;
      padding: 0em 0.1em;
      margin: 0 auto;
      display: inline-block;
      a {
        color: #575549;
        font-size: 0.8em;
      }
      li {
        padding: 0em 0.4em;
        border-bottom: none;
      }
    }
  }
`

function FacebookEmbedComponent(props) {
  //   const facebookEmbedCode = `
  // <div id="fb-root"></div>
  //       <script
  //         async
  //         defer
  //         crossorigin="anonymous"
  //         src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v23.0"
  //       ></script>
  //       <div
  //         class="fb-page"
  //         data-href={\`https://www.facebook.com/${props.facebookid}\`}
  //         data-tabs="timeline"
  //         data-width=""
  //         data-height=""
  //         data-small-header="true"
  //         data-adapt-container-width="true"
  //         data-hide-cover="true"
  //         data-show-facepile="false"
  //       >
  //         <blockquote
  //           cite={\`https://www.facebook.com/${props.facebookid}\`}
  //           class="fb-xfbml-parse-ignore"
  //         >
  //           <a href={\`https://www.facebook.com/${props.facebookid}\`}>
  //             Jersey Shore Center
  //           </a>
  //         </blockquote>
  //       </div>
  //   `

  const w = '285'
  const h = '499'
  const facebookEmbedCode = `
      <iframe
        src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2F${props.facebookid}&tabs=timeline&width=${w}&height=${h}&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=false&appId"
        width="${w}"
        height="${h}"
        style="border: none; overflow: hidden;margin: 0 auto; display:block "
        scrolling="no"
        frameborder="0"
        allowfullscreen="true"
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        sandbox="allow-top-navigation allow-scripts allow-forms allow-same-origin"
      ></iframe>
`

  return <div dangerouslySetInnerHTML={{ __html: facebookEmbedCode }} />
}

function CenterRightPanel(props) {
  return (
    <>
      {props.facebookid ? (
        <FacebookEmbedComponent facebookid={props.facebookid} />
      ) : null}
      {/* Desktop Menu */}
      <div className="d-md-inline m-0 p-0">
        <Link to="/findlocations" className="red-text-Genesis text-center">
          <MDBCardCompMenu className="font-weight-bold my-0 p-2">
            <MDBIcon
              icon="fas fa-map-marked-alt"
              size="3x"
              className="red-text-Genesis my-2"
            />
            <h5>Find a Location</h5>
          </MDBCardCompMenu>
        </Link>
        <a
          href={`https://g.page/r/${props.locationcode}/review`}
          className="red-text-Genesis text-center"
          role="button"
          tabIndex="0"
          target="_blank"
        >
          <MDBCardCompMenu className="my-2">
            <MDBCardBodyComp className="text-center m-0 p-2">
              <img src="/images/googlereviewlogo.png" />
            </MDBCardBodyComp>
          </MDBCardCompMenu>
        </a>
      </div>
    </>
  )
}

export default CenterRightPanel
